<template>
  <el-container v-loading="loading" id="top" style="height:1000px;">
    <el-header>
      <HeaderView :userName="viewUserName" />
    </el-header>
    <el-container>
      <el-container id="submenu" style="height:100%;overflow:auto;">
        <el-aside>
          <MenuView :cowMenuRadio="cow_menu_radio" :isAdmin="isAdmin" :userType="userType" :farmerId="farmer_id" />
        </el-aside>
      </el-container>
      <el-container id="sub" style="overflow:auto;">
        <el-main class="main">
          <el-scrollbar style="height: 100%;">
            <div class="main-inner">
              <div class="main-narrow">
                <p class="c-title">ライブモニタリングシステム「NiLIMo」&emsp;行動検知サービス利用規約</p>
                <br />
                <p class="c-header">第1章&emsp;総則</p>
                <p class="c-first">１．規約の範囲等</p>
                <p class="c-second">
                  (1)&nbsp;この利用規約（以下、「本規約」といいます）は、株式会社ニコン（以下、「弊社」といいます）が提供するニコンライブモニタリングシステム「NiLIMo」&emsp;行動検知サービス（以下、「本サービス」といいます）の利用条件等を定めるものです。
                </p>
                <p class="c-second">
                  (2)&nbsp;弊社が本サービスの提供に関してオンラインその他の方法により提示する諸規定、ガイドライン、特約等（以下、「諸規定」といいます）は、本規約と一体となって効力を有するものとします。なお、本規約と諸規定を総称して「サービス規約」といいます。
                </p>
                <p class="c-second">(3)&nbsp;本規約と諸規定の間に齟齬、矛盾がある場合には、特段の定めのない限り諸規定が優先するものとします。</p>
                <p class="c-second">(4)&nbsp;サービス規約の一部の条項に無効な条項があった場合であっても、サービス規約の他の条項は効力を失わないものとします。</p>
                <br />
                <p class="c-header">第2章&emsp;本サービス</p>
                <p class="c-first">１．本サービスの機能および制約条件</p>
                <p class="c-second">
                  (1)&nbsp;本サービスは、本サービスを利用される個人または法人（以下、「お客様」といいます）が、設置されたカメラから得られた映像を専用アプリケーションでモニターすることができ、牛の分娩兆候など特徴的な行動をAIが検知した場合には、その旨をお客様に通知するものをいいます。
                </p>
                <p class="c-second">
                  (2)&nbsp;弊社は、本サービスを利用するために必要となる、弊社が提供しない通信機器およびインターネット接続環境その他の制約条件（以下、「システム条件」といいます）を指定することがあります。ただし、本項に基づくシステム条件の指定は、本サービスが支障なく利用できることを弊社が保証するものではありません。
                </p>
                <p class="c-second">(3)&nbsp;システム条件は、お客様自らが準備し、またはその適否を確認する必要があり、また通信費用等システム条件を満たすための費用はお客様が負担するものとします。
                </p>
                <p class="c-second">(4)&nbsp;弊社は、本サービスが、すべてのウェブブラウザ、OS、端末等およびそれらのアップデートについて対応することを保証しないものとします。</p>
                <br />
                <p class="c-first">２．本サービスの開始</p>
                <p class="c-second-plus">
                  お客様は、本サービスの利用を開始するため、弊社もしくは本サービスの販売権を有する者と書面にて所定の契約手続きを行うものとします。お客様と弊社または本サービスの販売権を有する者との本サービスの利用にかかる契約を、以下、「本サービス契約」といいます。
                </p>
                <br />
                <p class="c-first">３．IDの使用と管理</p>
                <p class="c-second">(1)&nbsp;弊社は、本サービスを提供するにあたり、お客様が本サービスを利用するために必要なID（以下、「ID」といいます）を、お客様に対して発行するものとします。
                </p>
                <p class="c-second">
                  (2)&nbsp;お客様は、サービス規約に反するIDの利用が生じないよう、ID利用者による他者へのIDの開示または漏洩を防止する処置を図るなど、善良な管理者の注意義務を持ってIDを管理するものとし、第三者に対し、IDを譲渡、貸与、その他使用させてはならないものとします。
                </p>
                <p class="c-second">(3)&nbsp;お客様は、IDの使用・管理にかかる一切の責任を負うものとし、IDを用いて本サービスを利用する者の行為は、全てお客様による行為とみなされるものとします。
                </p>
                <br />
                <p class="c-first">４．禁止事項</p>
                <p class="c-second-plus">お客様は、本サービスの利用に際し、次の各号に該当する行為または該当すると弊社が判断する行為をしてはならないものとします。</p>
                <p class="c-third">(a)&nbsp;弊社に対して虚偽の事項を通知する行為。</p>
                <p class="c-third">(b)&nbsp;弊社に対し、正当な事由もなく長時間に渡り問合せを行い、または同様の問合せを繰り返し行うなど、弊社の業務に支障を来す行為。</p>
                <p class="c-third">(c)&nbsp;威嚇による嫌がらせ、恐喝または脅迫など、弊社の業務に支障を生じるおそれのある行為。</p>
                <p class="c-third">(d)&nbsp;他人の著作権、商標権等の知的財産権、肖像権もしくは営業秘密もしくはプライバシーを侵害する行為、または他人の名誉や信用を毀損する行為。</p>
                <p class="c-third">(e)&nbsp;他人の生命、健康、財産等を侵害する行為。</p>
                <p class="c-third">(f)&nbsp;他人に有形、無形の不利益、損害等を与える行為。</p>
                <p class="c-third">(g)&nbsp;公序良俗に反する行為。</p>
                <p class="c-third">(h)&nbsp;犯罪行為、または犯罪行為に結びつき、もしくは犯罪を助長する行為。</p>
                <p class="c-third">(i)&nbsp;コンピュータウイルス等有害なプログラムを使用または提供する行為。</p>
                <p class="c-third">(j)&nbsp;他人に成りすます行為または弊社の設備等に不正にアクセスしようとする行為。</p>
                <p class="c-third">(k)&nbsp;本サービスに用いられるセキュリティ技術を解読しようと試みる行為、または弊社が別途提供するソフトウェアの解析、変更等を試みる行為。</p>
                <p class="c-third">(l)&nbsp;本サービスに用いられるサーバのリソースを継続的に占有するなどして弊社の設備に過大な負荷を与えもしくは支障を及ぼす行為、またはそれらのおそれのある行為。
                </p>
                <p class="c-third">(m)&nbsp;第３章第６条に違反する行為。</p>
                <p class="c-third">(n)&nbsp;法令等に違反する行為、または他の利用者もしくは弊社に対する迷惑行為。</p>
                <p class="c-third">(o)&nbsp;前各号の行為を直接または間接に惹起し、または容易にする行為。</p>
                <p class="c-third">(p)&nbsp;その他弊社が不適切であると判断する行為。</p>
                <br />
                <p class="c-first">５．本サービスの停止および終了</p>
                <p class="c-second">
                  (1)&nbsp;弊社は、お客様が前条各号のいずれかの禁止行為を行った場合、その他下記各号に該当する場合、お客様に通知することなく直ちに本サービスの全部または一部の提供を停止または終了することができるものとします。
                </p>
                <p class="c-third">(a)&nbsp;お客様が過去にサービス規約に違反した、もしくは本条の措置を受けた、またはその関係者である場合。</p>
                <p class="c-third">(b)&nbsp;サービス規約に違反した場合。</p>
                <p class="c-second">
                  (2)&nbsp;弊社は、次の各号のいずれかに該当する場合、お客様に対して事前に通知することによって本サービスの全部または一部の提供を停止または終了することができるものとします。ただし、緊急やむをえない場合は、弊社は事前通知を行わず本サービスを停止または終了することができるものとします。
                </p>
                <p class="c-third">
                  (a)&nbsp;本サービスの提供に必要な設備、機器、システム、ソフトウェア等に対して、弊社または弊社の委託先等の第三者のいずれが実施するかを問わず、メンテナンスまたは工事を実施する必要がある場合。</p>
                <p class="c-third">(b)&nbsp;本サービスに用いられるハードウェアの滅失・毀損により、本サービスの停止が必要となった場合。</p>
                <p class="c-third">(c)&nbsp;その他弊社がやむをえない事由が生じたと判断した場合。</p>
                <p class="c-second">(3)&nbsp;弊社は、本条に基づき本サービスの提供を停止または終了した場合にお客様が被った損害について何ら責任を負わないものとします。</p>
                <br />
                <p class="c-first">６．本サービスの廃止または変更</p>
                <p class="c-second">(1)&nbsp;弊社は、お客様の承諾を得ることなく、本サービスの全部または一部を廃止または変更する事ができるものとします。</p>
                <p class="c-second">(2)&nbsp;弊社は、前項の規定により本サービスの廃止を行う場合には、お客様に対し廃止する6ヶ月以上前までに弊社の定める方法によりその旨を通知するものとします。</p>
                <br />
                <p class="c-first">７．コンテンツの責任</p>
                <p class="c-second">(1)&nbsp;弊社は、本サービスにより送受信される映像および通知（以下、「コンテンツ」といいます）の内容に関して何ら責任を負わないものとします。</p>
                <p class="c-second">
                  (2)&nbsp;お客様は、第三者の個人情報を不正に利用し、または第三者のプライバシー、著作権その他の権利を侵害し、もしくは名誉･信用等を害することになる恐れのある映像を本サービスにおいて利用しないものとします。
                </p>
                <p class="c-second">(3)&nbsp;お客様は、本サービスの利用にあたり、受信されるAI検知結果・通知の管理および利用は、お客様自らの責任でこれを行うものとします。</p>
                <p class="c-second">
                  (4)&nbsp;弊社の本サービスの提供にあたりお客様のコンテンツが、滅失、毀損、漏洩した場合といえども、その結果発生する直接あるいは間接の損害については、弊社は、いかなる責任も負わないものとします。ただし、弊社は、可能な限り当該滅失等の原因の解析および再発防止策について、誠意をもって策定するよう努めます。
                </p>
                <p class="c-second">
                  (5)&nbsp;お客様が本サービスの利用において、第三者の権利を侵害する行為、法令に違反する行為等を行った場合には、お客様が責任を負うものとし、弊社は一切の責任を負いません。お客様のコンテンツに関して、必要な許諾（著作権者による使用許諾、肖像権者による掲載の承諾など）は、お客様が取得するものとします。
                </p>
                <br />
                <p class="c-first">８．コンテンツ等の利用</p>
                <p class="c-second">
                  (1)&nbsp;本サービスを利用して得られたコンテンツについては、本サービスの運営、解析、プロモーション、改善、新しいサービスの開発等の目的のために、弊社（委託先や提携先を含みます。以下、本条において同じものとします。）が利用（使用、蓄積、保存、複製、変更、派生物の作成、送信、上映、表示、譲渡、貸与、頒布等をいいます。以下、本条において同じものとします。）できるものとします。お客様は、本項に基づく弊社による著作物（コンテンツ）の利用について、著作者人格権を行使しないものとします。
                </p>
                <p class="c-second">
                  (2)&nbsp;弊社は、お客様による本サービスの利用により、サーバ、端末またはその他の機器に蓄積された利用履歴、ログ等の情報を、障害解析その他本サービスの提供に関連する目的で利用することができるものとします。
                </p>
                <p class="c-second">
                  (3)&nbsp;お客様は、本サービスを利用してサーバに蓄積されたお客様のコンテンツを、提供元がお客様であることが特定できないように加工した統計データとして弊社が利用することについて、同意するものとします。
                </p>
                <p class="c-second">
                  (4)&nbsp;弊社は弊社の裁量によりコンテンツのバックアップを作成し、保管することができるものとします。ただし、全てのコンテンツがバックアップされることを保証するものではありません。弊社は、バックアップを前3項に定める目的のため、利用することができるものとします。
                </p>
                <br />
                <p class="c-first">９．委託・提携</p>
                <p class="c-second">(1)&nbsp;弊社は、本サービスの提供に関する業務の全部または一部をお客様の承諾なく第三者に対し委託することができるものとします。</p>
                <p class="c-second">(2)&nbsp;本サービスの一部は、弊社の提携先である第三者から提供される場合があります。</p>
                <br />
                <p class="c-first">10．サービス規約の変更</p>
                <p class="c-second-plus">
                  弊社は、お客様の承諾なく、サービス規約を変更することがあります。この場合、事前に相当の期間をおいて、本Webサイト上もしくは専用アプリケーション内に掲載します。なお、お客様がサービス規約の変更にご同意されない場合、本サービスの利用を停止の上、本サービス契約を終了してください。お客様がサービス規約変更後に本サービスを利用した場合は、変更後のサービス規約に同意したものとみなし、弊社は、当該変更後のサービス規約に基づいて、本サービスを提供します。
                </p>
                <br />
                <p class="c-header">第３章&emsp;一般条項</p>
                <p class="c-first">１．不保証</p>
                <p class="c-second">
                  (1)&nbsp;お客様は、本サービスは、お客様の利用環境等による影響を受け、また、通信設備、通信回線等に依拠することを認識し、本サービスに関連して、利用環境等、またはその他の原因を問わず、お客様の通信設備、通信回線に不具合および故障等の障害が発生した場合、および当該障害により本サービスが停止した場合でも、弊社は責任を負わないものとします。
                </p>
                <p class="c-second">
                  (2)&nbsp;お客様は、弊社が本サービスの完全性および有用性の保証、並びに第三者の権利を侵害しないことの保証を含め、本サービスに関していかなる保証もしないことを承諾するものとします。</p>
                <br />
                <p class="c-first">２．損害賠償責任</p>
                <p class="c-second">
                  (1)&nbsp;弊社は、本サービスの提供にあたり、お客様に生じた、事業または業務の中断および遅延並びに機会損失その他一切の損害および費用等については、その責任を負わないものとします。</p>
                <p class="c-second">
                  (2)&nbsp;前項にもかかわらず、弊社の責に帰すべきことが明らかな事由に基づき、弊社が本サービスに関連してお客様に発生した損害につき賠償責任を負う場合であっても、弊社は、当該事由の直接的結果として現実にお客様に発生した通常の範囲内の損害（特別損害、間接損害および逸失利益を除く）に限り、その賠償の責を負うものとします。この場合、弊社がお客様に支払う損害賠償額は、損害が発生した日（損害が継続的に発生した場合には損害の発生の理由がなくなった日）から遡って１２ヶ月間にお客様が損害の発生原因となった本サービスのために支払った料金等の合計額を限度とします。
                </p>
                <br />
                <p class="c-first">３．不可抗力</p>
                <p class="c-second-plus">
                  弊社は、天災地変（地震、津波、洪水、台風、竜巻、および火災を含みます）、戦争・騒乱、テロ行為、ストライキ、行政行為、法令改正、または弊社の支配の及ばない事由によってお客様に生じた、事業または業務の中断および遅延並びに機会損失その他一切の損害および費用等については、その責任を負わないものとします。
                </p>
                <br />
                <p class="c-first">４．法令規制等の遵守</p>
                <p class="c-second">
                  (1)&nbsp;お客様は、本規約に関連して、外国為替および外国貿易法等もしくはアメリカ合衆国輸出管理法等により定められる貨物または技術に該当するもの（以下、「法規制品」といいます）を輸出もしくは日本国外へ持ち出すにあたっては、外国為替および外国貿易法等もしくはアメリカ合衆国輸出管理法等に定められる手続きを遵守するものとします。
                </p>
                <p class="c-second">
                  (2)&nbsp;お客様は、法規制品並びにこれらの関連情報を、通常兵器、核兵器、生物・化学兵器およびミサイルの開発または製造に関連する第三者への輸出・販売または開示はしないものとします。</p>
                <p class="c-second">(3)&nbsp;お客様は、前各項に定める他、本規約に関して適用される一切の法令を遵守するものとします。</p>
                <br />
                <p class="c-first">５．秘密保持</p>
                <p class="c-second">(1)&nbsp;お客様は、本サービスの利用に際し知り得た情報を秘密に保持し、第三者に開示または漏洩しないものとします。</p>
                <p class="c-second">(2)&nbsp;お客様は、裁判所の命令もしくは法令に基づいて開示請求を受けた場合には、当該開示請求の定める範囲で前項の秘密保持義務を負わないものとします。</p>
                <p class="c-second">(3)&nbsp;前各項の定めにかかわらず、お客様は、次の各号に該当する情報については、本条第１項の秘密保持義務を負わないものとします。</p>
                <p class="c-third">(a)&nbsp;受領前に既に保有していた情報。</p>
                <p class="c-third">(b)&nbsp;正当な開示権限を有する第三者から秘密保持義務を負わずに受領した情報。</p>
                <p class="c-third">(c)&nbsp;受領時点で公知または公用である情報。</p>
                <p class="c-third">(d)&nbsp;受領後にお客様の責によらずに公知または公用となった情報。</p>
                <p class="c-third">(e)&nbsp;お客様が、本条第１項の情報によることなく、独自に開発した情報。</p>
                <br />
                <p class="c-first">６．反社会的勢力との関係排除</p>
                <p class="c-second">
                  (1)&nbsp;お客様は、お客様ご自身またはお客様の役員（名称の如何を問わず、経営および事業に実質的に関与している者をいいます）が、次の各号の一つにも該当しないことを誓約します。</p>
                <p class="c-third">
                  (a)&nbsp;暴力団、暴力団員、暴力団員でなくなった時から５年を経過しない者、暴力団準構成員、暴力団関係企業・団体、総会屋、社会運動・政治活動標ぼうゴロまたは特殊知能暴力集団等、その他これらに準ずる反社会的勢力（以下、これらを総称して「反社会的勢力」といいます）であること。
                </p>
                <p class="c-third">(b)&nbsp;反社会的勢力が出資、融資、取引その他の関係を通じて、お客様の事業活動に支配的な影響力を有すること。</p>
                <p class="c-third">(c)&nbsp;反社会的勢力が経営に実質的に関与していると認められる関係を有すること。</p>
                <p class="c-third">(d)&nbsp;自己もしくは第三者の不正の利益を図る目的、または第三者に危害を加える目的をもってするなど、不当に反社会的勢力を利用していると認められる関係を有すること。
                </p>
                <p class="c-third">(e)&nbsp;反社会的勢力に対して資金等を提供し、または便宜を供与していると認められる関係を有すること。</p>
                <p class="c-third">(f)&nbsp;反社会的勢力と社会的に非難されるべき関係を有すること。</p>
                <p class="c-second">(2)&nbsp;お客様は、本規約の履行が反社会的勢力の運営に資することがないこと、またはその活動を助長するおそれがないことを誓約します。</p>
                <p class="c-second">(3)&nbsp;お客様は、次の各号に該当する事項を行わないものとします。</p>
                <p class="c-third">(a)&nbsp;反社会的勢力を利用し、または反社会的勢力に対して資金、便宜の提供もしくは出資等の関与をする等、反社会的勢力と関係を持つこと。</p>
                <p class="c-third">(b)&nbsp;お客様が自らまたは第三者を利用して以下の行為を行うこと。</p>
                <p class="c-forth">(i)&nbsp;詐術、暴力的行為または脅迫的言辞を用いるなどすること。</p>
                <p class="c-forth">(ii)&nbsp;自らが反社会的勢力である旨を伝え、または関係団体もしくは関係者が反社会的勢力である旨を伝えるなどすること。</p>
                <p class="c-forth">(iii)&nbsp;弊社の名誉や信用等を毀損し、または毀損するおそれのある行為をすること。</p>
                <p class="c-forth">(iv)&nbsp;弊社の業務を妨害し、または妨害するおそれのある行為をすること。</p>
                <br />
                <p class="c-first">７．個人情報</p>
                <p class="c-second-plus">個人情報の取り扱いに関しては、弊社が別途制定する「個人情報保護について」の通りとします。</p>
                <br />
                <p class="c-first">８．権利義務の譲渡禁止</p>
                <p class="c-second-plus">
                  お客様は、本規約により生ずる権利または義務の全部または一部を第三者に譲渡してはならないものとします。ただし、弊社の書面による事前の承諾を得た場合はこの限りではありません。</p>
                <br />
                <p class="c-first">９．準拠法</p>
                <p class="c-second-plus">本規約の成立、効力、解釈および権利の得喪についての準拠法は、日本国法とします。</p>
                <br />
                <p class="c-first">10．管轄裁判所</p>
                <p class="c-second-plus">本規約に関連して紛争が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
                <br />
                <p class="c-first">11．協議</p>
                <p class="c-second-plus">弊社およびお客様は、本規約に定めのない事項または解釈上の疑義が生じた場合には、互いに信義誠実の原則に従って協議の上速やかに解決を図るものとします。</p>
                <br />
                <br />
                <p class="c-end">以&emsp;上</p>
              </div>
            </div>
          </el-scrollbar>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import HeaderView from '../components/HeaderView';
import MenuView from '../components/MenuView';
import { getCurrentUser, signout } from "./js/cognito";
import AWSAPI from './js/aws-api';
import { ElMessage } from 'element-plus';
import ConstParam from './js/const';

export default {
  name: 'TermsOfServiceView',
  components: {
    HeaderView,
    MenuView,
  },
  created() {
    this.$store.commit('setCowMenuSelect', '> 利用規約');
  },
  mounted() {
    this.restore_param();
    this.get_current_user();
  },
  data() {
    return {
      userType: ConstParam.disable_user_kind,
      // ===== 以降固定 ====
      isAdmin: false,
      cow_menu_radio: "",
      loading: true,
      userData: {},
      farmer_id: "",
      viewUserName: "",
      viewFarmerName: "",
      logOut: false
      // ==================
    };
  },
  methods: {
    restore_param() {
      // パラメータ復元
      this.isAdmin = this.$store.state.userAdmin;
    },
    // ===== 以降固定 ====
    get_current_user: async function () {
      // ログイン済みユーザー取得.
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.getUserSp3()
        .then((res) => {
          if (this.checkAnswer(res, true)) {
            this.userData = res['data']['data'][0];
          }
        });
    },
    get_id_token: async function () {
      try {
        const currentUser = await getCurrentUser();
        this.idToken = currentUser.idToken.jwtToken;
      } catch (e) {
        this.alertMessage("通知", ConstParam.relogin_message);
        this.$router.push('/login')
      }
    },
    viewMessage(message, status) {
      if (message === '') { return }
      if (status !== "error") {
        ElMessage({
          message: message,
          type: status
        });
      } else {
        ElMessage.error(message);
      }
    },
    checkAnswer(answer, autoLogout) {
      let message = "";
      try {
        const statusCode = answer.status;
        if (statusCode == 200) {
          // 正常応答
          if ("authToken" in answer) {
            this.idToken = answer.authToken;
            this.$cookies.set('Authorization', this.idToken);
          }
          return true;
        } else if (statusCode == 403) {
          // 共通鍵更新
          this.getCommonKey(this.publicKey_base64);
          return false;
        } else if (statusCode == 400 && answer.message.name === 'AxiosError') {
          // ユーザー削除のためログオフ
          this.loading = false;
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data &&
            answer.message.response.data.message === "User Not Found"
          ) {
            message = ConstParam.user_error_message;
          } else {
            if (
              "response" in answer.message &&
              "data" in answer.message.response &&
              "message" in answer.message.response.data
            ) {
              this.viewMessage(answer.message.response.data.message, "error");
            }
            return false;
          }
        } else if ((statusCode == 400 && 'message' in answer && answer.message.message === 'need login') ||
          (statusCode == 400 && 'message' in answer && answer.message.message === 'Refresh Token has expired') ||
          (statusCode == 400 && answer.message.message === "Network Error") || autoLogout) {
          // Token期限切れのため再ログイン
          this.loading = false;
          message = ConstParam.relogin_message;
        } else {
          // レスポンスのエラーメッセージの表示
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data
          ) {
            this.viewMessage(answer.message.response.data.message, "error");
          }
          return false;
        }
      } catch (e) {
        if (autoLogout) {
          // 自動ログアウト指定
          message = ConstParam.unknown_error_message
        } else {
          return false;
        }
      }
      if (!this.logOut) {
        // 多重処理防止のため
        this.logOut = true
        // ログオフ理由メッセージ通知
        if (this.message !== "") {
          this.alertMessage("通知", message);
        }
        this.click_user_signout();
      }
      return false;
    },
    alertMessage(title, message) {
      this.$alert(message, title, {
        confirmButtonText: 'OK'
      }).catch(() => {
        return
      });
    },
    click_user_signout: async function () {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          await signout();
        }
      } catch (e) {
        console.log("log out.");
      }
      this.$router.push('/login')
    },
    getAuthLevel(userData) {
      let ret = 0
      if ('user_type' in userData && userData.user_type) {
        ret = userData.user_type
      }
      return ret
    },
    getIsAdmin(authLevel) {
      let ret = true
      if (authLevel != 0) {
        ret = false
      }
      return ret
    }
  },
  watch: {
    // ===== 以降固定 ====
    userData: function () {
      if ('user_name' in this.userData) {
        this.viewUserName = this.userData['user_name'];
      }
      if ('farmer' in this.userData && 'farmer_name' in this.userData['farmer']) {
        this.viewFarmerName = this.userData['farmer']['farmer_name'];
      }
      if ('farmer' in this.userData && 'farmer_id' in this.userData['farmer']) {
        this.farmer_id = this.userData['farmer']['farmer_id'];
      }
      let tempUserType = this.getAuthLevel(this.userData)
      this.isAdmin = this.getIsAdmin(tempUserType)
      this.userType = tempUserType
      // パラメータ保存(権限)
      this.$store.commit('setUserAdmin', this.isAdmin);
      this.loading = false;
    }
    // ==================
  }
};
</script>

<style scoped>
.main {
  overflow: hidden;
  z-index: 1;
}

.main-inner {
  width: auto;
  max-width: 1400px;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 100px;
}

.main-narrow {
  max-width: 1280px;
  margin: 0 auto;
}

p {
  margin-block-start: 0em !important;
  margin-block-end: 0em !important;
  line-height: 3em;
  font-size: 18px;
  /* font-size: 20px; */
  color: #000;
}

.c-title {
  margin: 30px 0;
  text-align: center;
  position: relative;
}

.c-end {
  /* text-indent: 4em; */
  margin-left: 30em;
  text-indent: -1em;
  padding-left: 1em;
}

.c-header {
  /* text-indent: 0em; */
  margin-left: 0em;
  /* margin-top: 2em; */
}

.c-first {
  /* text-indent: 2em; */
  margin-left: 1em;
  /* margin-top: 1.5em; */
  text-indent: -1em;
  padding-left: 1em;
}

.c-second {
  /* text-indent: 4em; */
  margin-left: 3em;
  text-indent: -1em;
  padding-left: 1em;
}

.c-second-plus {
  /* text-indent: 4em; */
  margin-left: 3em;
  text-indent: 1em;
  padding-left: 0em;
}

.c-third {
  /* text-indent: 6em; */
  margin-left: 5em;
  text-indent: -1em;
  padding-left: 1em;
}

.c-forth {
  /* text-indent: 8em; */
  margin-left: 7em;
  text-indent: -1em;
  padding-left: 1em;
}
</style>